import React from "react";
import { SalesInquiryList } from "@pages/myPage/_component/index";

const SellInquiryTab = () => {
  return <SalesInquiryList />;
};

export default SellInquiryTab;
